import { action, observable } from 'mobx';
import type { RootStore } from './root.store';
import { Workspace } from '~/models/workspace.model';
import { IWorkspace } from '~/types/model.types';

// import type { BaseStore } from './base.store';

export class LegacyWorkspaceStore {
    @observable workspaces: Record<string, Workspace> = {};

    rootStore: RootStore = null;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    @action
    load(workspace: IWorkspace) {
        const newWorkspace = new Workspace(
            workspace,
            this.rootStore.companyStore,
            this.rootStore.userStore
        );
        this.workspaces[workspace._id] = newWorkspace;

        return newWorkspace;
    }
}
